<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-spreadsheet-file`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zM33 16a2 2 0 012 2v17a2 2 0 01-2 2H15a2 2 0 01-2-2V18a2 2 0 012-2h18zM20.514 26H16.6v7.4h3.914V26zm10.885 0h-7.885v7.4H31.4l-.001-7.4zm-10.885-6.401L16.6 19.6V23h3.914v-3.401zM31.4 19.6l-7.886-.001V23h7.885l.001-3.4z"/></svg>
</template>
<script>

export default {
  name: 'IconSpreadsheetFile',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
